import styles from './VServicesModalRentDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image from './image.jpg'

const VServicesModalRentDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Аренда складских помещений</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Гибкие решения по аренде складских помещений
                        </div>
                        <div className={styles.text}>
                            Независимо от размера вашего бизнеса, мы предлагаем гибкие варианты аренды складских помещений, чтобы соответствовать вашим потребностям. Наше разнообразие площадей позволяет выбрать оптимальное решение для вашего складского хранения.
                        </div>
                    </div>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Безопасное и надежное хранение:
                        </div>
                        <div className={styles.text}>
                            Мы понимаем важность безопасности вашего инвентаря и товаров. Наши складские помещения оборудованы современными системами безопасности, обеспечивая защиту вашего имущества в течение всего периода аренды.
                        </div>
                    </div>
                    
                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image} alt="Санитарная обработка аппаратов" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalRentDetails;